"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParameterByName = void 0;
exports.getParameterByName = function (name, url) {
    if (!name) {
        return '';
    }
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
//# sourceMappingURL=query-string.js.map